import { gql } from "@apollo/client";

export const CREATE_BRAND = gql(`
  mutation createBrand($input: CreateBrandInput!) {
    createBrand(input: $input) {
      id
      name
      logo
      description
      rating
      categories
      productsCount
      completedCollabs
      inviteCode
      status
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_BRAND = gql(`
  mutation updateBrand($input: UpdateBrandInput!) {
    updateBrand(input: $input) {
      id
      name
      logo
      description
      rating
      categories
      productsCount
      completedCollabs
      inviteCode
      status
      createdAt
      updatedAt
    }
  }
`);
